import { action, observable } from 'mobx';
import QuizItemSettings from './QuizItemSettings';


export class HiddenFieldItemSettings extends QuizItemSettings {
    constructor(s?: Partial<HiddenFieldItemSettings>) {
        super();
        if (s)
            this.update(s);
    }

    @observable value?: string;

    @action update(q: Partial<HiddenFieldItemSettings>, allowUndefined = false) {
        super.update(q, allowUndefined);
    }

    static build(def?: Partial<HiddenFieldItemSettings>) {
        return new HiddenFieldItemSettings({
            ...QuizItemSettings.default,
            value: undefined,
            ...def
        });
    }

    clone() {
        return new HiddenFieldItemSettings({
            ...this
        });
    }

    static fromJson(json: any) {
        return HiddenFieldItemSettings.build(json);
    }
}
